import { getTimeRemaining } from "./getTimeRemaining";
import { timeDOMIterator } from "./timeDOMSetIterator";

function getLastDayOfMonth(year, month) {

    let date = new Date(year, month, 1);
    date.setHours(23, 59, 0, 0);
    date.setDate(0);

    return date;
}
let today = new Date();

$(function () {
    const $timer = $('.js-timer');
    const $numbers = $timer.find(".js-timer-num");

    function updateClock() {
        let time = getTimeRemaining(getLastDayOfMonth(today.getFullYear(), today.getMonth() + 1));
        timeDOMIterator($numbers, time);
        if (time.total <= 0) clearInterval(timeinterval);
    }

    updateClock();
    let timeinterval = setInterval(updateClock, 1000);
});
